import { Controller } from "@hotwired/stimulus"

// Controlador Stimulus para auto-refresh via polling AJAX
//
// Uso:
// 1. Adicione data-controller="auto-refresh" no elemento
// 2. Adicione data-auto-refresh-url-value com a URL do endpoint de status
// 3. O controller faz polling a cada 20 segundos
// 4. Quando o status muda para 'done' ou 'error', recarrega a página
//
// Exemplo:
// <div data-controller="auto-refresh"
//      data-auto-refresh-url-value="/pt-BR/management_reports/123/status">
//   <button data-action="click->auto-refresh#refresh">Atualizar agora</button>
// </div>
export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    // Polling AJAX a cada 20 segundos
    this.interval = setInterval(() => {
      this.checkStatus()
    }, 20000)
  }

  stopPolling() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  async checkStatus() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          'Accept': 'application/json'
        }
      })

      if (!response.ok) {
        console.error('[AutoRefresh] Erro na requisição:', response.status)
        return
      }

      const data = await response.json()

      // Se o relatório finalizou (done ou error), recarrega a página
      if (data.status === 'done' || data.status === 'error') {
        this.stopPolling()
        window.location.reload()
      }
    } catch (error) {
      console.error('[AutoRefresh] Erro ao verificar status:', error)
    }
  }

  // Método para refresh manual via botão
  refresh(event) {
    event.preventDefault()
    window.location.reload()
  }
}
